import apiClient from './client'

export const gridApi = {
    /**
     * Lista dados genéricos de uma entidade pelo slug.
     * Para entidades tenant (ex: mercados), empresa_id é obrigatório.
     */
    list: async (
        slug: string,
        params?: { skip?: number; limit?: number; empresa_id?: number | null }
    ): Promise<any[]> => {
        const response = await apiClient.get<any[]>(`/grid/${slug}`, { params })
        return response.data || []
    },

    /**
     * Cria um item genérico
     */
    create: async (slug: string, data: Record<string, unknown>): Promise<any> => {
        const response = await apiClient.post<any>(`/grid/${slug}`, data)
        return response.data
    },

    /**
     * Atualiza um item genérico
     */
    update: async (slug: string, id: any, data: any): Promise<any> => {
        const response = await apiClient.put<any>(`/grid/${slug}/${id}`, data)
        return response.data
    }
}
